// Sticky menu
var mainNav = document.getElementById('main-nav');
var mainNavSticky = document.getElementById('main-nav-sticky-version');
var topMenu = document.getElementById('top-menu');
var body = document.body;
var topMenuPlaceholder = null;

function ensurePlaceholder(afterElement) {
    if (!afterElement) return null;
    var ph = document.getElementById('top-menu-placeholder');
    if (!ph) {
        ph = document.createElement('div');
        ph.id = 'top-menu-placeholder';
        ph.style.width = '100%';
        ph.style.height = '0px';
        ph.style.pointerEvents = 'none';
        ph.setAttribute('aria-hidden', 'true');
    }
    if (afterElement.parentNode) {
        var desiredNext = afterElement.nextSibling;
        if (ph.previousSibling !== afterElement) {
            afterElement.parentNode.insertBefore(ph, desiredNext);
        }
    }
    return ph;
}

function isWilbrink1() {
    return !!document.querySelector('[data-header-variant="wilbrink1"]');
}

function updateTopMenuOffset() {
    if (!topMenu || !body) return;

    if (isWilbrink1()) {
        body.style.marginTop = '0px';
        return;
    }

    var topMenuHeight = topMenu.offsetHeight;

    if (window.innerWidth < 1024 && topMenu.classList.contains('sticky')) {
        body.style.marginTop = topMenuHeight + 'px';
    } else {
        body.style.marginTop = '0px';
    }
}

function handleStickyMenu() {
    var scrollY = window.pageYOffset;
    var screenWidth = window.innerWidth;

    if (screenWidth >= 1024) {
        if (scrollY > mainNav.offsetTop) {
            mainNavSticky.classList.add('sticky');
            mainNavSticky.classList.remove('hidden');
            mainNav.style.opacity = '0';
        } else {
            mainNavSticky.classList.remove('sticky');
            mainNavSticky.classList.add('hidden');
            mainNav.style.opacity = '100';
        }

        if (topMenu) {
            topMenu.classList.remove('sticky');
            topMenu.style.position = '';
            topMenu.style.top = '';
            topMenu.style.left = '';
            topMenu.style.right = '';
            topMenu.style.width = '';
            topMenu.style.zIndex = '';
        }

        body.style.marginTop = '0px';
        if (topMenuPlaceholder) topMenuPlaceholder.style.height = '0px';
    }

    else {
        if (mainNavSticky) {
            mainNavSticky.classList.add('hidden');
            mainNavSticky.classList.remove('sticky');
        }
        if (mainNav) {
            mainNav.style.opacity = '100';
        }

        if (topMenu) {
            var wilbrink = isWilbrink1();
            if (wilbrink) {
                topMenu.classList.remove('sticky');
                topMenu.style.position = 'fixed';
                topMenu.style.top = '0';
                topMenu.style.left = '0';
                topMenu.style.right = '0';
                topMenu.style.width = '100%';
                topMenu.style.zIndex = '9999';
            } else {
                topMenu.style.position = '';
                topMenu.style.top = '';
                topMenu.style.left = '';
                topMenu.style.right = '';
                topMenu.style.width = '';
                topMenu.style.zIndex = '';

                if (scrollY > topMenu.offsetTop) {
                    topMenu.classList.add('sticky');
                } else {
                    topMenu.classList.remove('sticky');
                }
            }
            if (topMenuPlaceholder) topMenuPlaceholder.style.height = '0px';
            updateTopMenuOffset();
        }
    }
}

window.addEventListener('scroll', handleStickyMenu);
window.addEventListener('resize', handleStickyMenu);
window.addEventListener('resize', updateTopMenuOffset);
window.addEventListener('load', handleStickyMenu);
window.addEventListener('load', updateTopMenuOffset);
